import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import { isNil } from "ramda";
import dayjs from "dayjs";
import PageHeading from "../../../common/pageHeading/PageHeading";
import { fetchRequest as fetchPos } from "../../../store/pos/actions";
import { fetchRequest as fetchPosSoftware } from "../../../store/possoftware/actions";
import useSession from "../../../effects/useSession";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";
import { ApplicationState } from "../../../store";
import { Data, PosState } from "../../../store/pos/types";
import { Data as PosSoftwareData } from "../../../store/possoftware/types";
import { PosInterfaces } from "../posEdit/PosConstants";
import ItemsDetailViewSection from "../../../common/item/ItemsDetailViewSection";
import { Item, ItemDetail } from "../../../common/item/ItemDetailViewSection";
import PosViewDetail from './PosViewDetail'

export default function PosView(): React.ReactElement {
  const dispatch = useDispatch();
  const classes = pageStyles();
  const session = useSession();
  const [pos, setPos] = useState<Data | undefined>(undefined);

  const { id } = useParams<{ id: string }>();

  const posSoftwareState = useSelector(
    (state: ApplicationState) => state.posSoftware
  );
  const posState = useSelector((state: ApplicationState) => state.pos);

  const getById = (pos: PosState, id: string | undefined) => {
    return id && pos && pos.data && pos.data.data?.find((x) => x.id === id);
  };

  useEffect(() => {
    dispatch(fetchPosSoftware(null));
    !isNil(id) && dispatch(fetchPos(id));
  }, []);

  useEffect(() => {
    if (posSoftwareState?.data?.data) {
      const pos = getById(posState, id) as Data;
      setPos(pos);
    }
  }, [posState.data]);


  return (
    <Layout sessionData={session}>
      <main className={classes.content as string}>
        <div className={classes.appBarSpacer as string} />
        <Container maxWidth="lg" className={classes.container as string}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View Pos" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper as string}>
                <Box style={{ position: "relative" }}>
                  { pos && <PosViewDetail posData={pos} /> }
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
